import { render } from "./NavigationDesktopAllProducts.vue?vue&type=template&id=f79a1458"
import script from "./NavigationDesktopAllProducts.vue?vue&type=script&lang=js"
export * from "./NavigationDesktopAllProducts.vue?vue&type=script&lang=js"

import "./NavigationDesktopAllProducts.vue?vue&type=style&index=0&id=f79a1458&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__